import getMediaQuery from "../lib/media-queries.js"
import atBreakpointChange from "../lib/at-breakpoint-change.js"
import { liquidMadeVideoPlayer } from "../lib/video-player.js"

class VideoSection extends HTMLElement {
  constructor() {
    super()

    this.selectors = {
      currentVideoWrapper: "[js-current-video-wrapper]",
      mobileVideoTemplate: "[js-mobile-video-template]",
      videoTemplate: "[js-video-template]",
      videoPlayerContainer: "[js-video-player-container]",
    }
  }

  connectedCallback() {
    if (this.dataset.requiresTemplate === "true") {
      this.videoTemplate = this.querySelector(this.selectors.videoTemplate)
      this.mobileVideoTemplate = this.querySelector(
        this.selectors.mobileVideoTemplate,
      )
      this.currentVideoWrapper = this.querySelector(
        this.selectors.currentVideoWrapper,
      )

      this.#selectActiveTemplate()
      atBreakpointChange(720, this.#selectActiveTemplate.bind(this))
    } else {
      this.#initVideo()
    }
  }

  #selectActiveTemplate() {
    if (window.matchMedia(getMediaQuery("tablet")).matches) {
      this.#createVideo(this.videoTemplate)
    } else {
      this.#createVideo(this.mobileVideoTemplate)
    }
  }

  #createVideo(template) {
    const videoContent = template.content.cloneNode(true)

    this.currentVideoWrapper.innerHTML = ""
    this.currentVideoWrapper.append(videoContent)
    this.#initVideo()
  }

  #initVideo() {
    const videoPlayerContainer = this.querySelector(
      this.selectors.videoPlayerContainer,
    )

    liquidMadeVideoPlayer(videoPlayerContainer)
  }

  disconnectedCallback() {}
}

if (!customElements.get("video-section")) {
  customElements.define("video-section", VideoSection)
}
